import React, { Dispatch, SetStateAction, useState } from "react";
import {
    faAddressCard,
    faPlus,
    faSearch,
    faUserPlus,
} from "@fortawesome/free-solid-svg-icons";
import UnForm from "../../../Components/Form";
import Table from "../../../Components/Table";
import { ColumnDescription } from "react-bootstrap-table-next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CriarNovoLeadVendas from "../GestaoLeads/CriarNovoLead/CriarNovoLead";
import { IComponentModal } from "../../../Components/Modais/IModalComponent";
import ModalComponent from "../../../Components/Modais";
import { ListarClientesVendasController } from "../../../Controllers/Geral/GestaoClientes/GestaoClientesController";
import { ICliente } from "../../../Interfaces/Geral/GestaoClientes/GestaoClientesInterfaces";
import Swal from "sweetalert2";
import { IListProponentesResponse } from "../../../Interfaces/Vendas/Proponentes/ProponentesInterface";
import useAsyncCallback from "../../../hooks/useAsyncCallback";
import { ProponentesPostVendasController } from "../../../Controllers/Vendas/Proponentes/ProponentesController";
import { useAtendimentoPage } from "../../../Context/AtendimentoPage";
import paginationFactory from "react-bootstrap-table2-paginator";

interface IPesquisaProponentes {
    setShow: Dispatch<SetStateAction<boolean>>;
    ProponentesVendas: (...args: any[]) => Promise<IListProponentesResponse[]>;
}

export default function PesquisarProponentes(props: IPesquisaProponentes) {
    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();

    const [page, setPage] = useState(1);
    const [pesquisa, setPesquisa] = useState("");
    const { ID_CASO } = useAtendimentoPage();

    const {
        execute: ProponentesPostVendas,
        loading: ProponentesPostVendasLoading,
    } = useAsyncCallback(ProponentesPostVendasController);

    const {
        execute: ListarClientesVendas,
        loading: ListarClientesVendasLoading,
        value: lstProponentes,
    } = useAsyncCallback(ListarClientesVendasController);

    function ListaProponentes({ proponente }: { proponente: ICliente }) {
        return (
            <div className="d-flex justify-content-between flex-wrap align-items-center px-2 py-1">
                <div className="d-flex flex-column flex-wrap">
                    <div>
                        <span className="card-title text-hover-primary font-weight-bolder font-size-h3 text-dark mb-1 mr-3">
                            {proponente.DS_NOME
                                ? proponente.DS_NOME.length > 40
                                    ? proponente.DS_NOME.substring(0, 40) +
                                      "..."
                                    : proponente.DS_NOME
                                : ""}
                        </span>
                        {proponente.NR_CPF ? (
                            <span
                                className="label label-light-primary label-inline"
                                style={{ height: "auto" }}
                            >
                                <FontAwesomeIcon
                                    icon={faAddressCard}
                                    className="mr-1"
                                />{" "}
                                {proponente.NR_CPF}
                            </span>
                        ) : (
                            <div></div>
                        )}
                    </div>
                    <span className="text-muted font-weight-bold">
                        {proponente.DS_EMAIL}
                    </span>
                </div>
                <button
                    className="btn btn-outline-success"
                    onClick={() => {
                        Swal.fire({
                            title: "Adicionar Proponente",
                            text: "Deseja adicionar o proponente a venda?",
                            icon: "question",
                            showCancelButton: true,
                            confirmButtonText: "Sim",
                            cancelButtonText: "Não",
                        }).then((result) => {
                            if (result.isConfirmed) {
                                ProponentesPostVendas({
                                    ID_CASO: ID_CASO,
                                    ID_CONTA: proponente.ID_CONTA,
                                }).then(() => {
                                    props.setShow(false);
                                    props.ProponentesVendas();
                                });
                            }
                        });
                    }}
                    disabled={ProponentesPostVendasLoading}
                >
                    Adicionar
                </button>
            </div>
        );
    }

    const columns: Array<ColumnDescription> = [
        {
            dataField: "ID_CONTA",
            text: "Proponente",
            formatter: (_, row) => {
                return <ListaProponentes proponente={row} />;
            },
            sort: true,
            isDummyField: true,
            headerClasses: "d-none",
        },
    ];

    const handleSearch = (formData: { DS_PESQUISA: string }) => {
        setPesquisa(formData.DS_PESQUISA);
        ListarClientesVendas(formData.DS_PESQUISA);
    };

    return (
        <div>
            <div className="text-center">
                <h2 className="font-weight-bold">Adicionar Proponente</h2>
                <p className="text-muted font-weight-bold">
                    Entre com o nome, e-mail, telefone ou CPF do proponente
                </p>
            </div>
            <UnForm handleSubmit={handleSearch}>
                <div className="form-group border-bottom py-3 b-5">
                    <div className="d-flex flex-inline justify-content-center align-items-center w-100">
                        <div className="col-md-10">
                            <UnForm.Input
                                name="DS_PESQUISA"
                                placeholder="Pesquisar por Nome, Email, Telefone ou CPF"
                                className={`form-control h-auto border-0 px-0 placeholder-dark-75`}
                            />
                        </div>
                        <div className="col-md-2">
                            <UnForm.SubmitButton
                                color="success"
                                icon={faSearch}
                                className="btn btn-success font-weight-bold px-6 py-3 my-2"
                                disabled={
                                    ListarClientesVendasLoading ||
                                    ProponentesPostVendasLoading
                                }
                            >
                                Buscar
                            </UnForm.SubmitButton>
                        </div>
                    </div>
                </div>
            </UnForm>
            {lstProponentes && (
                <Table
                    columns={columns}
                    keyField="ID_CONTA"
                    data={lstProponentes ?? []}
                    loading={ListarClientesVendasLoading}
                    noSearch
                    striped
                    pagination={paginationFactory({
                        sizePerPage: 5,
                        page,
                        onPageChange: (page, sizePerPage) => {
                            setPage(page);
                            ListarClientesVendas(pesquisa ?? "");
                        },
                    })}
                    bordered={false}
                    noDataIndication={() => (
                        <div className="text-muted text-center">
                            Nenhum proponente encontrado
                        </div>
                    )}
                    noPagination
                />
            )}
            <div className="card-footer d-flex justify-content-end pt-2 p-0">
                <button
                    className="btn btn-outline-success"
                    onClick={() => {
                        setShow(true);
                        setModal({
                            Children: <CriarNovoLeadVendas />,
                            IconHeader: faPlus,
                            headerComponent: "Novo Proponente",
                            size: "xl",
                        });
                    }}
                >
                    <FontAwesomeIcon icon={faUserPlus} /> Criar Conta Proponente
                </button>
            </div>
            <ModalComponent
                ModalComponent={modal}
                show={show}
                setShow={setShow}
            />
        </div>
    );
}
